<template>
  <div class="card">
    <div class="card-header">{{userShippingType.shipping_type.name.replace(/_/g, " ") }}</div>
    <div class="card-body">
      <form @submit.prevent="setUserShippingType()">

        <div class="form-group col-md-12 mb-3">
          <b-form-checkbox v-model="userShippingType.enabled" :disabled="!isCompanyAdmin" :value="1" :unchecked-value="0" switch>
            <translate>Shipping Type Enabled</translate>
          </b-form-checkbox>
        </div>

        <h5 v-translate>Title quote</h5>

        <div class="form-group col-md-12 mb-3">
          <label class="control-label" v-translate>Title quote</label>
          <div class="input-group">
            <input class="form-control col-md-6" v-model="userShippingType.title" />
            <div class="input-group-append" v-show="showDeliveryDays">
              <span class="input-group-text" style="border-width: 0 0 1px; font-size: 13px;">{{deliveryDay}}</span>
            </div>
          </div>
        </div>

        <div class="form-group col-md-12 mb-3" v-show="hasDescription">
          <label class="control-label" v-translate>Description</label>
          <div class="input-group">
            <input class="form-control col-md-6" v-model="userShippingType.description" />
          </div>
        </div>

        <div class="mb-3">
          <b-col cols="6" order="1">
            <b-form-checkbox v-model="showDeliveryDays" :value="1" :unchecked-value="0">
              <translate>Show delivery date</translate>
            </b-form-checkbox>
          </b-col>
        </div>

        <div class="form-group col-md-12 mb-3" v-show="showDeliveryDays">
          <label for="from_extra" v-translate>Packaging days</label>
          <div class="input-group">
            <input class="form-control col-md-6" type="number" v-model="userShippingType.packaging_days" required />
          </div>
          <small v-show="!isPackaginDaysValid" class="text-danger form-text" v-translate>Days must be greater than or equal to 0</small>
          <small class="form-text text-muted" v-translate>Set to 0 to offer same day shippings</small>
        </div>

        <hr>
        <h5 class="card-title" v-translate>Pricing</h5>
        <h6 class="card-subtitle mb-2 text-muted" v-translate>Edit the price your client will see when making a quote</h6>

        <div class="form-group col-md-12 mb-3">
          <b-row>
            <div class="form-group col-sm-3">
              <label></label>
              <b-form-checkbox v-model="hasFreeShipping" :value="true" :unchecked-value="false">
                <translate>Offer free shipping</translate>
              </b-form-checkbox>
            </div>

            <div class="form-group col-sm-7" v-show="hasFreeShipping">
              <label v-translate>Amount for free shipping</label>
              <div class="input-group">
                <input class="form-control" type="number" step="0.01" v-model="userShippingType.amount_for_free_shipping" />
              </div>
            </div>
          </b-row>
        </div>

        <div class="form-group col-md-12 ">
          <label v-translate>Pricing options</label>
          <b-form-radio-group class="mb-3" v-model="specialPricing">
            <b-form-radio value="default"><translate>Default</translate></b-form-radio>
            <b-form-radio value="static"><translate>Static price</translate></b-form-radio>
            <b-form-radio value="range"><translate>Range price</translate></b-form-radio>
            <b-form-radio value="fixed"><translate>Default + Fixed Price</translate></b-form-radio>
          </b-form-radio-group>

          <b-row v-show="specialPricing === 'default'">
            <b-col>
              <p v-translate>The price shown to the client will be calculated in base of the distance and the volume of the package</p>
            </b-col>
          </b-row>
          <b-row v-show="specialPricing === 'range'">
            <div class="col-sm-12">
              <p v-translate>Select the minimum and maximum price your client can pay for a shipping</p>
            </div>
            <div class="form-group col-sm-5">
              <label v-translate>Minimum price</label>
              <div class="input-group">
                <input class="form-control" type="number" step="0.01" v-model="userShippingType.min_price"/>
              </div>
            </div>
            <div class="form-group col-sm-5">
              <label v-translate>Maximum price</label>
              <div class="input-group">
                <input class="form-control" type="number" step="0.01" v-model="userShippingType.max_price"/>
                <small v-show="!isRangePriceValid" class="text-danger form-text" v-translate>Maximum price must be greater than or equal to minimum price</small>
              </div>
            </div>
          </b-row>
          <b-row v-show="specialPricing === 'static'">
            <div class="col-sm-12">
              <p v-translate>The client will see a fixed price when they make a quote</p>
            </div>
            <div class="form-group col-sm-5">
              <label for="from_address" v-translate>Static price</label>
              <div class="input-group">
                <input class="form-control" type="number" step="0.01" v-model="userShippingType.min_price"/>
              </div>
            </div>
          </b-row>
          <b-row v-show="specialPricing === 'fixed'">
            <div class="col-sm-12">
              <p v-translate>The client will see a price calculated in base of the distance and the volume of the package plus a fixed extra price defined below</p>
            </div>
            <div class="form-group col-sm-5">
              <label for="from_address" v-translate>Fixed extra price</label>
              <div class="input-group">
                <input class="form-control" type="number" step="0.01" v-model="userShippingType.fixed_over_price"/>
              </div>
            </div>
          </b-row>
        </div>

        <div class="form-group col-md-12">
          <b-button type="submit" variant="primary" v-translate :disabled="!isPackaginDaysValid || !isRangePriceValid">Save</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userShippingType: {
      type: Object,
      default: () => {}
    },
    application: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showDeliveryDays: this.userShippingType.show_delivery_days,
      hasDescription: this.$route.params.slug === 'shopify-v2',
      specialPricing: '',
      hasFreeShipping: true
    }
  },
  computed: {
    deliveryDay() {
      switch (parseInt(this.userShippingType.packaging_days)) {
        case 0:
          return this.$gettext('today!')
        case 1:
          return this.$gettext('tomorrow!')
        default: {
          const translate = this.$gettext('in %{packagingDays} working days!')
          return this.$gettextInterpolate(translate, {
            packagingDays: this.userShippingType.packaging_days
          })
        }
      }
    },
    isPackaginDaysValid() {
      if (this.showDeliveryDays) {
        return this.userShippingType.packaging_days >= 0
      }
      return true
    },
    isRangePriceValid() {
      const rangePriceIsComplete = this.userShippingType.min_price && this.userShippingType.max_price
      if (this.specialPricing !== 'range' || !rangePriceIsComplete) {
        return true
      }
      return parseFloat(this.userShippingType.min_price) <= parseFloat(this.userShippingType.max_price)
    }
  },
  beforeMount() {
    this.setSpecialPricing()
  },
  methods: {
    setSpecialPricing() {
      this.hasFreeShipping = (this.userShippingType.amount_for_free_shipping !== null)

      if (this.userShippingType.fixed_over_price) {
        this.specialPricing = 'fixed'
      } else if (this.userShippingType.min_price && this.userShippingType.min_price !== this.userShippingType.max_price) {
        this.specialPricing = 'range'
      } else if (this.userShippingType.min_price && this.userShippingType.min_price === this.userShippingType.max_price) {
        this.specialPricing = 'static'
      } else {
        this.specialPricing = 'default'
      }
    },
    setUserShippingType() {
      const update = {
        ...this.userShippingType,
        show_delivery_days: this.showDeliveryDays
      }

      if (this.specialPricing === 'static') {
        update.fixed_over_price = null
        update.max_price = update.min_price
      } else if (this.specialPricing === 'default') {
        update.fixed_over_price = null
        update.max_price = null
        update.min_price = null
      } else if (this.specialPricing === 'fixed') {
        update.max_price = null
        update.min_price = null
      }

      if (this.hasFreeShipping === false) {
        update.amount_for_free_shipping = null
      }

      if (this.$route.params.slug === 'shopify-v2') {
        return this.setMicroserviceShippingType(update)
      }
      delete update.id
      const url = this.$appConfig.api.baseUrl + 'users/' + this.$store.state.auth.uid + '/shipping-types/' + this.userShippingType.id
      this.$http.patch(url, update)
        .then(response => {
          this.$emit('success-updating', true)
        })
        .catch(error => {
          const obj = {
            title: 'ERROR',
            message: error,
            type: 'error',
            customCloseBtnText: this.$gettext('Close')
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        })
    },
    async setMicroserviceShippingType(update) {
      const mapped = {
        enabled: update.enabled,
        title: update.title,
        description: update.description,
        packagingDays: update.packaging_days,
        showDeliveryDays: update.show_delivery_days,
        amountForFreeShipping: update.amount_for_free_shipping ? Number(update.amount_for_free_shipping) : '',
        fixedOverPrice: update.fixed_over_price ? Number(update.fixed_over_price) : '',
        minPrice: update.min_price ? Number(update.min_price) : '',
        maxPrice: update.max_price ? Number(update.max_price) : '',
        type: update.shipping_type.name,
        id: update.id
      }
      mapped.platformId = this.$appConfig.integrations['shopify-v2'].platformId
      const path = this.$appConfig.integrations.ecommerce.baseUrl + 'shopify/update-store?appId=' + this.application.id
      const headers = { 'x-api-key': this.$appConfig.integrations.ecommerce.header, Authorization: this.application.key }
      try {
        const { data } = await this.$http.post(path, mapped, { headers })
        console.log(data)
        this.$emit('success-updating', true)
      } catch (e) {
        const obj = {
          title: 'ERROR',
          message: e,
          type: 'error',
          customCloseBtnText: this.$gettext('Close')
        }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
      }
    }
  }
}
</script>
